<template>
  <div class="multiselect-wrapper">
    <label :for="id" class="label">{{ label }}</label>
    <div class="selected-items-container">
      <div class="selected-items">
        <span
          v-for="item in selectedLabels"
          :key="item.value"
          class="selected-item"
        >
          {{ item.label }}
          <button
            type="button"
            class="remove-btn"
            @click="removeItem(item.value)"
          >
            ×
          </button>
        </span>
        <span v-if="selectedLabels.length === 0" class="placeholder">
          Select options...
        </span>
      </div>
    </div>
    <button
      type="button"
      class="toggle-btn"
      @click="showOptions = !showOptions"
    >
      {{ showOptions ? "Hide Options" : "Show Options" }}
    </button>
    <div v-if="showOptions" class="options-dropdown">
      <div
        v-for="option in sortedOptions"
        :key="option.value"
        class="option-item"
      >
        <input
          type="checkbox"
          :id="`${id}-${option.value}`"
          :value="option.value"
          :checked="localValue.includes(option.value)"
          @change="toggleOption(option.value)"
        />
        <label :for="`${id}-${option.value}`" class="option-label">
          {{ option.label }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localValue: [],
      showOptions: false
    };
  },
  computed: {
    selectedLabels() {
      if (!Array.isArray(this.localValue)) {
        return [];
      }
      return this.localValue.map(val => ({
        value: val,
        label: this.data.options.find(opt => opt.value === val)?.label || val
      }));
    },
    sortedOptions() {
      const options = Array.isArray(this.data.options) ? this.data.options : [];

      // Sort alphabetically by label
      return options.slice().sort((a, b) => {
        const labelA = (a.label || "").toLowerCase();
        const labelB = (b.label || "").toLowerCase();
        return labelA.localeCompare(labelB);
      });
    }
  },
  watch: {
    localValue(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.localValue = Array.isArray(val) ? val : [];
    }
  },
  methods: {
    toggleOption(value) {
      if (this.localValue.includes(value)) {
        this.localValue = this.localValue.filter(item => item !== value);
      } else {
        this.localValue = [...this.localValue, value];
      }
    },
    removeItem(value) {
      this.localValue = this.localValue.filter(item => item !== value);
    }
  },
  mounted() {
    this.localValue = Array.isArray(this.value) ? this.value : [];
  }
};
</script>

<style lang="scss" scoped>
.multiselect-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.label {
  font-weight: 500;
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
}

.selected-items-container {
  width: 100%;
  min-height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  background-color: #f9f9f9;
  display: flex;
  align-items: flex-start;
}

.selected-items {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  width: 100%;
  align-content: flex-start;
}

.placeholder {
  color: #999;
  font-size: 13px;
  padding: 4px 0;
}

.selected-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #e3f2fd;
  border: 1px solid #90caf9;
  border-radius: 16px;
  padding: 4px 8px;
  font-size: 13px;
  white-space: nowrap;
}

.remove-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  padding: 0;
  line-height: 1;
  flex-shrink: 0;
  display: flex;
  align-items: center;

  &:hover {
    color: #d32f2f;
  }
}

.toggle-btn {
  padding: 8px 12px;
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1976d2;
  }
}

.options-dropdown {
  width: 100%;
  max-height: 250px;
  overflow-y: auto;
  border: 1px solid #2196f3;
  border-radius: 4px;
  background-color: #fff;
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.option-item {
  display: flex;
  align-items: center;
  padding: 8px 4px;
  cursor: pointer;
  border-radius: 3px;
  transition: background-color 0.15s;

  &:hover {
    background-color: #f5f5f5;
  }

  input[type="checkbox"] {
    margin-right: 10px;
    cursor: pointer;
    width: 16px;
    height: 16px;
  }
}

.option-label {
  cursor: pointer;
  flex: 1;
  margin-bottom: 0;
  font-size: 13px;
  user-select: none;
}
</style>
